import { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { attemptToJoinExam, finishExam, getSchoolName, leaveExam, saveAttemptCurrentQuestionIndex } from "../../assets/api/userActions";
import CountDown from "../../components/countDown/countDown";
import Swal from 'sweetalert2';


// import HomeworkQuestion from '../../components/homeworkQuetion';

import UploadButtons from '../../components/uploadButtons';
import DescriptiveQuestion from "../../components/descriptiveQuestion";
import { ReactComponent as Exit } from '../../assets/icons/exit.svg';
import { ReactComponent as Refresh } from '../../assets/icons/RightSquare.svg';

import classes from '../../App.module.scss';
import { checkMatchQuestionURL, hasAnswerContent, safeParseLocalStorageJson } from "../../assets/utils/utils";
import Loading from "../../components/loading/loading";
import { useLeaveExamOnTabClose } from "../../hooks/useLeaveExamOnTabClose";
import { showExamExitConfirmSwal } from "../../assets/utils/examExitConfirmSwal";
import { confirmForwardOnlySkipUnanswered } from "../../assets/utils/forwardOnlyNextConfirmSwal";

function DescriptiveExam() {

    const navigate = useNavigate();
    const params = useParams();

    const [activeBtn, setActiveBtn] = useState(null);
    const [examData, setExamData] = useState();
    const [userAnswered, setUserAnswered] = useState()
    const [examDataAttempt, setExamDataAttempt] = useState();
    const [isLoading, setIsLoading] = useState(true);
    const [timeLeft, setTimeLeft] = useState(0);
    const [totalTime, setTotalTime] = useState(0);
    const [answered, setAnswered] = useState();
    const [schoolName, setSchoolName] = useState("");
    const [unAnswered, setUnAnswered] = useState()
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const fetchInProgress = useRef(false);
    const storedUser = safeParseLocalStorageJson("userToken");

    const isInThePast = useCallback((date) => {
        const today = new Date();
        return date < today;
    }, []);

    const toLoginPage = useCallback(() => {
        localStorage.removeItem("userToken");
        navigate(`/quiz/join/${params.quiz}`);
    }, [navigate, params.quiz]);

    const fetchSchoolName = useCallback(async () => {
        await getSchoolName(params.quiz).then((res) => setSchoolName(res.schoolName));
    }, [params.quiz]);

    const fetchData = useCallback(async (options = {}) => {
        const preserveQuestionIndex = options.preserveQuestionIndex === true;
        const data = await attemptToJoinExam(params.quiz);
        if (data?.status === "attempt-finished") {
            navigate('/quiz/finish');
            setIsLoading(false);
            return;
        }
        if (data?.status !== "joined") {
            let a = data?.message;
            a = a.split("{").join("");
            a = a.split("}").join("");
            if (a.includes("date")) {
                a = a.replace("date", data?.date);
            }
            if (a.includes("time")) {
                a = a.replace("time", data?.time);
            }
            Swal.fire({
                icon: "error",
                title: `${a}`,
            });
            setTimeout(() => {
                navigate("/quiz/join/" + params.quiz);
            }, "2000");
        }

        data?.attempt?.answers && setUserAnswered(checkMatchQuestionURL(data.quiz, data.attempt));
        setExamData(data);
        setExamDataAttempt(data.attempt);
        setTimeLeft(data.attempt.timer);
        setTotalTime(data.attempt.total_time);
        setIsLoading(false);
        setAnswered(data.attempt.answered_questions);
        setUnAnswered(data.attempt.unanswered_questions);
        if (!preserveQuestionIndex) {
            const qCount = data.quiz?.questions?.length ?? 0;
            const maxIdx = Math.max(0, qCount - 1);
            const isOneByOne =
                data.quiz?.question_type === "custom" && data.quiz?.questions_display_mode === "one_by_one";
            if (isOneByOne && data.attempt) {
                const raw = data.attempt.current_question_index;
                const n = typeof raw === "number" ? raw : parseInt(raw, 10);
                const idx = Number.isFinite(n) ? Math.min(Math.max(0, n), maxIdx) : 0;
                setCurrentQuestionIndex(idx);
            } else {
                setCurrentQuestionIndex(0);
            }
        }
        return data.quiz.title;
    }, [params.quiz, navigate]);

    function clickedOn(){
        fetchData();
    }

    const refreshExamAfterAnswer = () => fetchData({ preserveQuestionIndex: true });



    const onFinishHandler = async (e) => {
        const res = await finishExam(e);
        if (res?.status === 'success-finish') {
            navigate('/quiz/finish');
            return;
        }
        throw new Error(res?.message || 'امکان اتمام آزمون نیست');
    };

    const onLeaveHandler = async (e) => {
        const res = await leaveExam(e);
        if (res?.status === 'success-leave') {
            navigate('/quiz/join/' + params.quiz);
            return;
        }
        throw new Error(res?.message || 'امکان ترک آزمون نیست');
    };

    const showExitConfirm = (leave) => {
        const isLeaveExam = !!leave;
        showExamExitConfirmSwal({
            isLeaveExam,
            unansweredCount: isLeaveExam ? 0 : unAnswered,
            onConfirm: async () => {
                if (isLeaveExam) await onLeaveHandler(examDataAttempt.id);
                else await onFinishHandler(examDataAttempt.id);
            },
        });
    };

    useLeaveExamOnTabClose(examData?.quiz?.leave, examDataAttempt?.id);

    useEffect(() => {
        const LSdata = safeParseLocalStorageJson("userToken");
        if (!LSdata) {
            navigate(`/quiz/join/${params.quiz}`);
            return;
        }
        if (LSdata && isInThePast(LSdata.expireDate)) {
            toLoginPage();
            return;
        }
        if (fetchInProgress.current) return;
        fetchInProgress.current = true;
        const examTitlePromise = fetchData();
        fetchSchoolName();
        examTitlePromise.finally(() => {
            fetchInProgress.current = false;
        });
        examTitlePromise.then((res) => res && (document.title = `آزمون ${res}`));
    }, [params.quiz, navigate, fetchData, fetchSchoolName, toLoginPage, isInThePast]);

    function answerAttemptResHandler(data) {
        if (!data) return;
        setAnswered(data.answered_questions);
        setUnAnswered(data.unanswered_questions);
        setExamDataAttempt((prev) => (prev ? { ...prev, ...data } : data));
        setExamData((prev) => {
            if (!prev?.quiz) return prev;
            const mergedAttempt = { ...(prev.attempt || {}), ...data };
            setUserAnswered(checkMatchQuestionURL(prev.quiz, mergedAttempt));
            return { ...prev, attempt: mergedAttempt };
        });
    }


    const activeBtnHandler = (index) => {
        setActiveBtn(index);
    }
    const nullingActiveBtnHandler = () => {
        setActiveBtn(null);
    }

    const questions = examData?.quiz?.questions || [];
    const isCustomQuiz = examData?.quiz?.question_type === "custom";
    const isOneByOneMode = isCustomQuiz && examData?.quiz?.questions_display_mode === "one_by_one";
    const isForwardOnlyMode = isOneByOneMode && examData?.quiz?.question_navigation_mode === "forward_only";
    const currentQuestion = questions[currentQuestionIndex];
    const isRandomOrder = examData?.quiz?.questions_order_mode === "random" || !!examData?.quiz?.random_questions;
    const isLastOneByOneQuestion =
        isOneByOneMode && questions.length > 0 && currentQuestionIndex >= questions.length - 1;

    const getQuestionDisplayNumber = (question, index) => {
        if (isRandomOrder) return index + 1;
        return question?.question_number ?? (index + 1);
    };

    const getDescriptiveAnswerSheetMode = (questionId, index) => {
        if (!isForwardOnlyMode) return 'active';
        if (index < currentQuestionIndex) {
            const ans = examDataAttempt?.answers?.find((a) => a.question_id === questionId);
            return hasAnswerContent(ans) ? 'past_answered' : 'past_unanswered';
        }
        if (index > currentQuestionIndex) return 'future';
        return 'active';
    };

    const goToPreviousQuestion = () => {
        setCurrentQuestionIndex((prev) => {
            if (prev <= 0) return prev;
            const next = prev - 1;
            if (isOneByOneMode && examDataAttempt?.id) {
                saveAttemptCurrentQuestionIndex(examDataAttempt.id, next);
            }
            return next;
        });
    };

    const goToNextQuestion = async () => {
        const max = questions.length - 1;
        if (currentQuestionIndex >= max) return;

        if (isForwardOnlyMode) {
            const q = questions[currentQuestionIndex];
            const ans = examDataAttempt?.answers?.find((a) => a.question_id === q?.id);
            if (!hasAnswerContent(ans)) {
                const ok = await confirmForwardOnlySkipUnanswered("descriptive");
                if (!ok) return;
            }
        }

        setCurrentQuestionIndex((prev) => {
            if (prev >= max) return prev;
            const next = prev + 1;
            if (isOneByOneMode && examDataAttempt?.id) {
                saveAttemptCurrentQuestionIndex(examDataAttempt.id, next);
            }
            return next;
        });
    };

    return (
        <div className={`${classes.appContainer} ${classes.examAppContainer}`}>
            {
                !isLoading ?

                    examData && <div className={classes.container}>
                        <header className={classes.timeRemainedContainer} style={{ display: 'grid' }}>
                            <div className={classes.headerBox}>
                                <div className={classes.buttonContainer}>
                                    <p className={classes.finishExamBtn} onClick={() => showExitConfirm(false)}>اتمام آزمون</p>
                                    {examData.quiz.leave ? (
                                        <p className={classes.leaveExamBtn} onClick={() => showExitConfirm(true)}>ترک آزمون</p>
                                    ) : null}
                                </div>
                                {timeLeft !== "unlimited" ? <CountDown totalTime={totalTime} timeRemained={timeLeft} attemptID={examDataAttempt?.id} /> : <p className={classes.unlimited_text}>زمان باقیمانده : نامحدود</p>}
                                {/* <div className='time-remained'>4:20:00</div> */}
                            </div>
                            <div className={classes.informationBar}>
                                <div className={classes.examDetails}>
                                    <div className={classes.examDetailsTitle}>
                                        <h1>{examData.quiz.title}</h1>
                                        <p>{`(${schoolName})`}</p>
                                    </div>
                                    <div id={classes.returnBtn}>
                                        <p>بازگشت به سایت</p>
                                        <div className={classes.exitIcon}>
                                            <Exit fill='#fff' width="15px" height='15px' />
                                        </div>
                                    </div>
                                </div>
                                <div className={classes.personalDetails}>
                                    <ul>
                                        <li>{`نام کاربر : ${storedUser?.name ?? ""}`}</li>
                                        <li>{`مدت آزمون : ${examData?.quiz?.duration ? examData?.quiz?.duration +" دقیقه " : "نامحدود" }`}</li>
                                        <li>{`نوع آزمون : ${examData.quiz.type === "test" ? "تستی" : "تشریحی"}`}</li>
                                        <li>{`نمره کل : ${examData.quiz.total_score}`}</li>
                                        <li>{`تعداد سوالات : ${examData.quiz.number_of_question}`}</li>
                                    </ul>
                                </div>
                            </div>
                        </header>

                        <main className={classes.mainContainer}>
                            <div className={classes.answerSheetContainer}>
                                <div className={classes.answerSheetHeader}>
                                    <h3>پاسخنامه</h3>
                                    <div className={classes.answerDatasheet}>
                                        <p className={classes.answerDatasheet_answer}>{`پاسخ داده شده : ${answered === null ? 0 : answered}`}</p>
                                        <p className={classes.answerDatasheet_notAnswer}>{`پاسخ داده نشده : ${unAnswered === null ? 0 : unAnswered}`}</p>
                                    </div>
                                </div>
                                <div className={classes.uploadAnswersSheet}>
                                    <ol>
                                        {
                                            examData.quiz?.questions?.map((data, index) => (
                                                <UploadButtons
                                                    key={data.id}
                                                    index={data.id} quNo={getQuestionDisplayNumber(data, index)} options={data.options} score={data.score}
                                                    activeBtn={activeBtn} attemptID={examDataAttempt.id}
                                                    activeBtnHandler={activeBtnHandler} answerAttemptRes={answerAttemptResHandler}
                                                    userAnswered={userAnswered} clickedOn={clickedOn}
                                                    nullingActiveBtnHandler={nullingActiveBtnHandler}
                                                    onAnswerUpdated={refreshExamAfterAnswer}
                                                    answerSheetPrimaryQuestionId={
                                                        isOneByOneMode && currentQuestion
                                                            ? currentQuestion.id
                                                            : undefined
                                                    }
                                                    questionBody={data.body}
                                                    question={data}
                                                    questionImage={data.image}
                                                    questionVoice={data?.voice}
                                                    answerSheetMode={getDescriptiveAnswerSheetMode(data.id, index)}
                                                />
                                            ))
                                        }

                                    </ol>
                                </div>
                            </div>
                            {/* DISPLAY QUESTION / QUESTION SECTION  */}
                            <section className={classes.questionSection}>
                                <div className={classes.questionSection_header}>
                                    <h2>سوالات آزمون</h2>
                                    <div className={classes.reloadBtn} onClick={() => window.location.reload()}>
                                        <p>بارگذاری مجدد</p>
                                        <div id={classes.refreshIcon}>
                                            <Refresh />
                                        </div>
                                    </div>
                                </div>
                                <div className={classes.questionContainer}>
                                    {
                                        isOneByOneMode ? (
                                            <>
                                                {isForwardOnlyMode && (
                                                    <div style={{ marginBottom: 12, padding: 12, borderRadius: 8, background: "#fff7ed", color: "#9a3412" }}>
                                                        شما در حالت نمایش تکی و بدون بازگشت هستید. با رفتن به سوال بعد، امکان برگشت به سوالات قبل وجود ندارد.
                                                    </div>
                                                )}
                                                {currentQuestion && (
                                                    <DescriptiveQuestion key={currentQuestion.id} data={currentQuestion} id={currentQuestion.id} options={currentQuestion.options} quNo={getQuestionDisplayNumber(currentQuestion, currentQuestionIndex)}
                                                        body={currentQuestion.body} score={currentQuestion.score} imageURL={currentQuestion.image} audioURL={currentQuestion?.voice} question={currentQuestion}
                                                    />
                                                )}

                                                <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", marginTop: 12 }}>
                                                    {!isForwardOnlyMode && (
                                                        <button
                                                            type="button"
                                                            className={classes.examInfo__btn}
                                                            onClick={goToPreviousQuestion}
                                                            disabled={currentQuestionIndex === 0}
                                                        >
                                                            سوال قبلی
                                                        </button>
                                                    )}

                                                    {!isForwardOnlyMode && questions.map((question, index) => (
                                                        <button
                                                            key={question.id}
                                                            type="button"
                                                            className={classes.examInfo__btn}
                                                            style={{ opacity: index === currentQuestionIndex ? 1 : 0.75 }}
                                                            onClick={() => {
                                                                setCurrentQuestionIndex(index);
                                                                if (isOneByOneMode && examDataAttempt?.id) {
                                                                    saveAttemptCurrentQuestionIndex(examDataAttempt.id, index);
                                                                }
                                                            }}
                                                        >
                                                            {getQuestionDisplayNumber(question, index)}
                                                        </button>
                                                    ))}

                                                    {isLastOneByOneQuestion ? (
                                                        <button
                                                            type="button"
                                                            className={classes.examInfo__btnFinish}
                                                            onClick={() => showExitConfirm(false)}
                                                        >
                                                            پایان آزمون
                                                        </button>
                                                    ) : (
                                                        <button
                                                            type="button"
                                                            className={classes.examInfo__btn}
                                                            onClick={goToNextQuestion}
                                                        >
                                                            سوال بعدی
                                                        </button>
                                                    )}
                                                </div>
                                                {isForwardOnlyMode && (
                                                    <p style={{ marginTop: 10, color: "#6b7280" }}>
                                                        سوال {getQuestionDisplayNumber(currentQuestion, currentQuestionIndex)} از {questions.length}
                                                    </p>
                                                )}
                                            </>
                                        ) : (
                                            examData.quiz?.questions?.map((data, index) => (
                                                <DescriptiveQuestion key={data.id} data={data} id={data.id} options={data.options} quNo={getQuestionDisplayNumber(data, index)}
                                                    body={data.body} score={data.score} imageURL={data.image} audioURL={data?.voice} question={data}
                                                />
                                            ))
                                        )
                                    }
                                </div>
                            </section>
                        </main>

                    </div> :
                    <>
                        <Loading />
                    </>
            }
        </div>
    );
}

export default DescriptiveExam;
